export default [
    {
        component: () => import(/* webpackChunkName: 'web-service-almoxarifado-cliente-fabricante' */ '@/views/web-service/almoxarifado/cliente/fabricante/Index'),
        path: 'almoxarifado-cliente-fabricante',
        redirect: 'almoxarifado-cliente-fabricante/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'web-service-almoxarifado-cliente-fabricante' */'@/views/web-service/almoxarifado/cliente/fabricante/List.vue'),
                name: 'web-service-almoxarifado-cliente-fabricante-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'web-service-almoxarifado-cliente-fabricante' */ '@/views/web-service/almoxarifado/cliente/fabricante/Form.vue'),
                name: 'web-service-almoxarifado-cliente-fabricante-create',
                path: 'create',
            },
            {
                component: () => import(/* webpackChunkName: 'web-service-almoxarifado-cliente-fabricante' */ '@/views/web-service/almoxarifado/cliente/fabricante/Form.vue'),
                name: 'web-service-almoxarifado-cliente-fabricante-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
            },
        ],
    },
]